import React from 'react';
import { Field } from 'react-final-form';
import { Toggle, InputFieldV2Adapter, TextareaFieldAdapter } from '@zola/zola-ui';

// TODO: We popped this off the flow for ease of getting this live
// But may revisit? Commenting until decisions are made
// import PasswordSettingsForm from 'components/manage/website/ManagePagesRedesign/DropDownForms/PasswordSettingsForm/PasswordSettingsForm';

import { FormDropdown, FormInput } from 'components/common/form/FinalFormV2Elements';

import EventTypes from 'components/manage/events/util/EventTypes';
import * as Validations from 'components/common/form/commonValidations';
import { AttireLabel } from 'pages/Events/EventForm/FormBody/components/FieldLabels/FieldLabels';

import css from './formFields.module.less';

export const renderEventTypeField = className => (
  <FormDropdown
    name="type"
    options={EventTypes}
    label="Event Type"
    validate={[Validations.REQUIRED]}
    className={className}
    placeholder="Select..."
  />
);

export const renderEventTitleField = className => (
  <FormInput
    name="name"
    label="Event Title"
    placeholder="Our Wedding"
    maxChars={100}
    validate={[Validations.REQUIRED, Validations.MAX_LENGTH_100]}
    className={className}
  />
);

export const renderEventDescriptionField = () => (
  <Field name="note" validate={Validations.MAX_LENGTH_200}>
    {props => (
      <TextareaFieldAdapter
        id="event-description"
        label="Event Description"
        placeholder="We are so happy that you can share in this moment with us."
        rows={4}
        maxChars={200}
        {...props}
      />
    )}
  </Field>
);

export const renderEventAttireField = (openSuggestionModal, setAttire) => {
  const onShowAttireSuggestions = callback => openSuggestionModal(callback);
  return (
    <Field name="attire">
      {props => (
        <InputFieldV2Adapter
          id="event-attire"
          label={<AttireLabel onClick={() => onShowAttireSuggestions(val => setAttire(val))} />}
          placeholder="Casual"
          type="text"
          maxChars={400}
          validate={Validations.MAX_LENGTH_400}
          {...props}
        />
      )}
    </Field>
  );
};

export const renderEventToggles = () => (
  <div className={css.toggleSection}>
    <div className={css.toggleInput}>
      <label htmlFor="public" className={css.toggleLabel}>
        Make event public to all guests
      </label>
      <Field name="public" initialValue>
        {props => (
          <Toggle
            withIcons
            inline={false}
            id="public"
            ariaLabel="Make event public to all guests"
            {...props}
          />
        )}
      </Field>
    </div>
    <div className={css.toggleInput}>
      <label htmlFor="collect_rsvps" className={css.toggleLabel}>
        Let guests RSVP on website
      </label>
      <Field name="collect_rsvps">
        {props => (
          <Toggle
            withIcons
            inline={false}
            id="collect_rsvps"
            ariaLabel="Let guests RSVP on website"
            {...props}
          />
        )}
      </Field>
    </div>
    {/* <PasswordSettingsForm /> */}
  </div>
);

export default {
  renderEventTypeField,
  renderEventTitleField,
  renderEventDescriptionField,
  renderEventAttireField,
  renderEventToggles,
};



// WEBPACK FOOTER //
// ./src/components/manage/VirtualEvents/common/FormFields/FormFields.jsx